import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getJobDetails,
  getSkillDetails,
} from "../../../services/profileService";
import DetailsDialog from "../../dialog/detailsDialog";

const DetailsDialogs = ({ dialog, setDialog }) => {
  const [jobDetails, setJobDetails] = useState(null);
  const [skillDetails, setSkillDetails] = useState(null);
  const [badges, setBadges] = useState([]);
  const [skills, setSkills] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (dialog.skillId) {
      getSkillDetails(dialog.skillId).then((skillResponse) => {
        setSkillDetails(skillResponse.data);
        const skillMicroSkills = skillResponse.data.microSkills.map(
          (mircoSkill) => ({
            id: mircoSkill.microSkillCode,
            name: mircoSkill.microSkillName,
          })
        );
        setSkills(skillMicroSkills);
        setBadges([
          {
            label: t("profileScreen.detailsDialog.skillCategoryLabel"),
            description: skillResponse.data.category,
          },
          {
            label: t("profileScreen.detailsDialog.parentSkillLabel"),
            description: skillResponse.data.parentSkill,
          },
        ]);
      });
    } else {
      getJobDetails(dialog.jobId).then((jobResponse) => {
        setJobDetails(jobResponse.data);
        const jobSkills = jobResponse.data.successProfileSkills.map(
          (skill) => ({
            id: skill.skillId,
            name: skill.skillName,
            rank: skill.skillRank,
          })
        );
        setSkills(jobSkills.sort((a, b) => a.rank - b.rank));
        setBadges([
          {
            label: t("profileScreen.detailsDialog.businessCapabilityLabel"),
            description: jobResponse.data.businessCapabilityName,
          },
          {
            label: t("profileScreen.detailsDialog.disciplineLabel"),
            description: jobResponse.data.disciplineName,
          },
          {
            label: t("profileScreen.detailsDialog.jobFamilyLabel"),
            description: jobResponse.data.jobFamilyName,
            ignoreIcon: true,
          },
        ]);
      });
    }
  }, []);

  return (
    <DetailsDialog
      open={jobDetails !==null || skillDetails !==null}
      setDialog={setDialog}
      header={dialog.skillId ? skillDetails?.name : jobDetails?.jobName}
      description={
        dialog.skillId ? skillDetails?.description : jobDetails?.jobDescription
      }
      badges={badges}
      proficiencyLevels={skillDetails}
      proficiencyLevel={dialog?.proficiencyLevel}
      skills={skills}
      skillsTitle={
        dialog.skillId
          ? t("profileScreen.detailsDialog.microSkills")
          : t("profileScreen.detailsDialog.skills")
      }
    />
  );
};

export default DetailsDialogs;
